<template>
  <div class="row">
    <div class="col-12">
      <c-table
        ref="table"
        title="사용자별 패널티 목록"
        :isTitle="true"
        :columns="grid.columns"
        :merge="grid.merge"
        :gridHeight="gridHeight"
        :data="tabParam.ctoPenaltyModels"
        :filtering="false"
        :gridHeightAuto="true"
        :isExcelDown="false"
        :columnSetting="false"
        :usePaging="false"
        noDataLabel="사용자별 패널티를 추가하세요."
        :hideBottom="true"
        :editable="editable&&!disabled"
        rowKey="userPenaltyId"
        selection="multiple"
      >
        <template  v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'userName'">
            {{ props.row.userName }}
            <span>
              <div v-if="editable && !disabled">
                <q-btn-group outline class="ColumInnerBtnGroup">
                  <template v-for="(btn, idx) in col.btns">
                    <q-btn
                      :key="idx"
                      :label="btn.label"
                      :icon="btn.icon ? btn.icon : void 0"
                      :color="btn.color ? btn.color : 'blue-grey-4'"
                      :text-color="btn.textColor ? btn.textColor : 'white'"
                      class="ColumInnerBtn"
                      align="center"
                      @click.stop="innerBtnClicked(col, props, btn)">
                      <q-tooltip v-if="btn.tooltip">
                        <span v-html="btn.tooltip" />
                      </q-tooltip>
                    </q-btn>
                  </template>
                </q-btn-group>
              </div>
            </span>
          </template>
        </template>
        <template slot="table-button">
          <!-- <q-btn-group outline >
            <c-btn v-if="editable && !disabled" label="추가" icon="add" @btnClicked="addPenalty" />
            <c-btn v-if="editable && !disabled && tabParam.ctoPenaltyModels.length > 0" label="삭제" icon="remove" @btnClicked="removePenalty" />
            <c-btn
              v-if="editable && !disabled && tabParam.ctoPenaltyModels.length > 0"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="tabParam.ctoPenaltyModels"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="savePenalty"
              @btnCallback="saveCallback" 
            />
          </q-btn-group> -->
        </template>
      </c-table>
    </div>
    <div class="popup-bottom-bar">
      <div class="popup-bottom-bar-btngroup">
         <q-btn-group outline >
          <c-btn :flat="true" v-if="editable && !disabled" label="추가" icon="add" @btnClicked="addPenalty" />
          <c-btn :flat="true" v-if="editable && !disabled && tabParam.ctoPenaltyModels.length > 0" label="삭제" icon="remove" @btnClicked="removePenalty" />
          <c-btn
            :flat="true" 
            v-if="editable && !disabled && tabParam.ctoPenaltyModels.length > 0"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="tabParam.ctoPenaltyModels"
            mappingType="POST"
            label="저장"
            icon="save"
            @beforeAction="savePenalty"
            @btnCallback="saveCallback" 
          />
        </q-btn-group>
      </div>
      <div class="popup-bottom-bar-close">
        <q-btn flat color="gray" icon="arrow_back" @click="closePopUps" />
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'cto-penalty',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        sopCtoId: '',
        ctoCompleteFlag: '',
        ctoPenaltyModels: [],
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      grid: {
        merge: [
          { index: 0, colName: 'userId' },
        ],
        columns: [
          {
            name: 'userName',
            field: 'userName',
            label: '사용자명',
            align: 'center',
            btns: [
              { label: '', icon: 'add', color: 'orange', tooltip: '패널티 항목 추가' },
            ],
            required: true,
            type: 'custom',
            sortable: true,
          },
          {
            name: 'penaltyPoint',
            field: 'penaltyPoint',
            label: '페널티',
            style: 'width: 100px',
            type: 'number',
            required: true,
            align: 'right',
          },
          {
            name: 'penaltyDt',
            field: 'penaltyDt',
            label: '페널티 부과일',
            align: 'center',
            type: 'date',
            required: true,
            style: 'width: 150px',
          },
          {
            name: 'penaltyReason',
            field: 'penaltyReason',
            label: '페널티 부과 사유',
            type: 'text',
            align: 'left',
          },
        ],
        height: '750px',
        data: [],
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: 'transactionConfig.sop.cto.checklist.save.url',
      saveType: 'POST',
      deleteUrl: 'transactionConfig.sop.cto.checklist.delete.url',
      isSave: false,
      title: '',
      comboItems: [],
    };
  },
  computed: {
    disabled() {
      return this.editable && Boolean(this.tabParam.ctoCompleteFlag) && this.tabParam.ctoCompleteFlag === 'Y'
    },
    gridHeight() {
      return String(this.contentHeight - 100) + 'px';
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      this.saveUrl = transactionConfig.sop.cto.penalty.save.url;
      this.deleteUrl = transactionConfig.sop.cto.penalty.delete.url;
      
    },
    /* eslint-disable no-unused-vars */ 
    savePenalty() {
      let isProgress = true;
        this.$_.forEach(this.tabParam.ctoPenaltyModels, cto => {
        if (Number(cto.penaltyPoint) === 0) {
          isProgress = false
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '[' + cto.userName + ']사용자의 패널티 점수를 0보다 높게 입력하세요.',
            type: 'warning', // success / info / warning / error
          });
          return false;
        }
      })
      if (isProgress) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(this.tabParam.ctoPenaltyModels, item => {
              item.regUserId = this.$store.getters.user.userId
              item.chgUserId = this.$store.getters.user.userId
              item.sopCtoId = this.tabParam.sopCtoId
            })
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getDetail')
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    addPenalty() {
      this.popupOptions.title = '사용자 검색'; // 사고자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.tabParam.ctoPenaltyModels, {
            userId: _item.userId,
          });
          if (index === -1) {
            this.tabParam.ctoPenaltyModels.splice(0, 0, {
              editFlag: 'C',
              sopCtoId: this.tabParam.sopCtoId,  // cto 일련번호
              userPenaltyId: uid(),  // 벌점부과 일련번호
              userId: _item.userId,  // 사용자ID
              userName: _item.userName,  // 사용자ID
              penaltyDt: this.$comm.getToday(),  // 벌점부과일
              penaltyPoint: null,  // 벌점
              penaltyReason: '',  // 벌점부과 사유
            });
          }
        })
      }
    },
    removePenalty() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getList();
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.tabParam.ctoPenaltyModels = this.$_.reject(this.tabParam.ctoPenaltyModels, item);
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    innerBtnClicked(col, props) {
      this.tabParam.ctoPenaltyModels.splice(props.rowIndex+1, 0, {
        editFlag: 'C',
        sopCtoId: this.tabParam.sopCtoId,  // cto 일련번호
        userPenaltyId: uid(),  // 벌점부과 일련번호
        userId: props.row.userId,  // 사용자ID
        userName: props.row.userName,  // 사용자ID
        penaltyDt: this.$comm.getToday(),  // 벌점부과일
        penaltyPoint: null,  // 벌점
        penaltyReason: '',  // 벌점부과 사유
      });
    },
    closePopUps() {
      this.$emit('closePopup')
    },
  }
};
</script>
